import { MainButton } from '@eventr/common-storybook'
import { useParams } from 'react-router-dom'
import { useEditSectionContext } from '../../feat/editItinerary/editSectionProvider'
import i18n from '../../i18n/i18next'

interface IEditButton {
    id?: string
    data: any
    renderOptions: IEditButtonOptions
}
interface IEditButtonOptions {
    pageId?: number
}

export const EditButton = ({ id, data, renderOptions }: IEditButton) => {
    const { section } = useEditSectionContext()

    const { idItem } = useParams<{
        idItem: string
    }>()
    const path = () => {
        if (renderOptions.pageId) {
            return (
                '/edit/Section/' +
                section?.id +
                '/' +
                idItem +
                '/' +
                renderOptions.pageId +
                '/' +
                data._id
            )
        } else {
            return '/edit/Section/' + section?.id + '/' + data._id
        }
    }
    return (
        <MainButton
            id={id + 'editButton'}
            icon="Edit"
            text={i18n.t('general.edit')}
            size="small"
            onClick={() => {
                window.pushPath(path())
            }}
        />
    )
}
